import { render, staticRenderFns } from "./Inscription.vue?vue&type=template&id=0cf990be&scoped=true&"
import script from "./Inscription.vue?vue&type=script&lang=js&"
export * from "./Inscription.vue?vue&type=script&lang=js&"
import style0 from "./Inscription.vue?vue&type=style&index=0&id=0cf990be&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cf990be",
  null
  
)

export default component.exports